<div [class.display-none]="loading">
  @if (!rawInput) {
    <video
      id="{{ videoId }}"
      #video
      class="azuremediaplayer amp-default-skin"
      controls
      >
      <p class="amp-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that supports HTML5 video
      </p>
    </video>
  }
  @if (rawInput) {
    <video
      width="100%"
      height="400px"
      class="azuremediaplayer video-player"
      controls
      controlsList="nodownload"
      oncontextmenu="return false;"
      #rawVideoPlayer
      (play)="onRawVideoStarted()"
      preload="metadata"
      [attr.autoplay]="autoplay ? 'autoplay' : null"
      [poster]="poster"
      >
      <source src="{{ src }}" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  }
</div>
